module.exports = __webpack_public_path__ + "static/media/file-png.b35d4fe9.svg";